import React, { useEffect , useState} from "react";
import "./Profile.css";
import { useSelector } from "react-redux";
import { fetchProfile } from "../../Api/Login";
import { useNavigate } from "react-router-dom";

const Profile = () => {
  const navigate = useNavigate()
  const token = useSelector(state => state.login.token);
const [profile, setProfile] = useState({})

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchProfile(token)
        setProfile(response.data)
        console.log(response.data)
    } catch (error) {
      }   
    }
    fetchData()
  }, [])
  
 
  return (
    <div className="profile-container">
      <div className="profile-header">
        <h1>Profile</h1>
        <button className="save-button" onClick={() => navigate('/profile/editProfile')}>Edit</button>
      </div>
      <div className="profile-content">
        <div className="profile-logo-section">
          <div className="profile-logo">
            <img src={profile.logo} alt="Profile Logo" />
          </div>
        </div>
        <div className="profile-details">
          <p>Store Name</p>
          <input
            type="text"
            className="profile-input profile-name"
            value={profile.storeName}
            name="name"
          />
           <p>Owner Name</p>
          <input
            type="text"
            className="profile-input profile-name"
            value={profile.name}
            name="name"
          />
          <p>Registered Mobile Number</p>
          <input
            type="text"
            className="profile-input"
            value={profile.phone}
            name="phone"
           
          />
          <p>Email</p>
          <input
            type="email"
            className="profile-input"
            value={profile.email}
            name="email"
          />
          <p>Address</p>
          <textarea
            className="profile-input"
            rows="2"
            value={profile.address}
            name="address"
           
          ></textarea>
          <p>GST Number</p>
          <input
            type="text"
            className="profile-input"
            value={profile.gst}
            name="gst"
         
          />
          <p>Return Policy</p>
          <textarea
            className="profile-input"
            rows="4"
            value={profile.returnPolicy}
            name="returnPolicy"
         
          ></textarea>
          <p>Description</p>
          <textarea
            className="profile-input"
            rows="4"
            value={profile.description}
            name="description"
          
          ></textarea>
        </div>
      </div>
    </div>
  );
};

export default Profile;
